import React from "react";
import {
  Box,
  // makeStyles,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {gql, useSubscription} from "@apollo/client";
import LoadingWall from "../../components/loadingWall";
const perPage = 20;
// const useStyles = makeStyles({
//   customTableContainer: {
//     overflowX: "initial",
//   },
// });
const TICKERS_SUBSCRIPTION = gql`
  subscription TICKERS($first: Int=${perPage}, $skip: Int=0) {
    tickers(first: $first, skip: $skip) {
      edges {
        cursor
        node {
          id
          price
          name
          ticker
          oneDayChange,
    oneWeekChange,
    oneMonthChange,
    threeMonthChange,
    sixMonthChange,
    oneYearChange,
    ytdChange,
    fiveYearChange,

    marketCap
    volume
    stockImage
    volumeUsd
    gap
    ATH
    ATL
    wk52h
    wk52l


        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`;
const Market = () => {
  const tableHeader = [
    "ticker",
    "name",
    "price",
    "oneDayChange",
    "oneWeekChange",
    "oneMonthChange",
    "threeMonthChange",
    "sixMonthChange",
    "oneYearChange",
    "ytdChange",
    "fiveYearChange",
    "marketCap",
    "volume",
    "volumeUsd",

    "gap",
    "ATH",
    "ATL",
    "wk52h",
    "wk52l",
  ];
  const [page, setPage] = React.useState(1);
  const {data, loading} = useSubscription(TICKERS_SUBSCRIPTION, {
    variables: {
      first: perPage,
      skip: (page - 1) * perPage,
    },
  });
  //console.log("🚀 ~ file: index.tsx:27 ~ Market ~ data:", data);

  const rows = data?.tickers?.edges?.map((edge) => ({...edge.node, name: edge.node.name.slice(0, 10)})) || [];

  if (loading) return <LoadingWall />;
  return (
    <div className="">
      <TableContainer className="" style={{overflowX: "initial"}}>
        <Box className="MarketMain ">
          <Table sx={{minWidth: 420}} aria-label="customized table" stickyHeader>
            <TableHead>
              <TableRow>
                {tableHeader.map((header, key) =>
                  header == "ticker" ? (
                    <TableCell align="center" key={key} className="sticky left-0 bg-black" style={{zIndex: 999}}>
                      {header}
                    </TableCell>
                  ) : (
                    <TableCell align="center" key={key}>
                      {header}
                    </TableCell>
                  )
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={tableHeader.length}>no data</TableCell>
                </TableRow>
              ) : (
                <>
                  {rows.map((row, key) => (
                    <TableRow key={key}>
                      {tableHeader.map((column, key) =>
                        column == "ticker" ? (
                          <TableCell align="center" key={key} className="sticky left-0 bg-black">
                            <div>
                              <img src={row.stockImage} style={{width: "20px", height: "20px"}} />
                              {row[column]}
                            </div>
                          </TableCell>
                        ) : (
                          <TableCell align="center" key={key}>
                            {row?.[column]}
                          </TableCell>
                        )
                      )}
                    </TableRow>
                  ))}
                </>
              )}
            </TableBody>
          </Table>
          <Pagination
            count={Math.ceil(data?.tickers?.totalCount / perPage)}
            color="primary"
            page={page}
            onChange={(_e, page) => setPage(page)}
          />
        </Box>
      </TableContainer>
    </div>
  );
};

export default Market;
